import { Head } from "vite-react-ssg";

function TermsAndConditions() {
  return (
    <>
      <Head>
        <title>Terms of service </title>
        <meta
          name="description"
          content=" Answers to FAQs about us, our process, easy payments, how we secure intellectual property, all of our services in general and careers at our company."
        />
        <link rel="canonical" href="https://apptalyst.com/terms-of-service" />
      </Head>

      <section className="bg-[#f7f9fd] py-20 md:py-32 px-4">
        <div className="container  mt-20">
          <h1 className="text-2xl md:text-3xl text-dark  pb-5 font-sans">
            Please review our very transparent terms of service
          </h1>
          <h2 className="text-xl md:text-2xl text-dark  pb-5">
            Effective Date: 04/28/2025
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            Please read these Terms of Service (“Terms”) carefully before
            using our website or services.
          </p>
          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            1. Use of Website
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            By accessing our website, you agree to comply with these Terms. If
            you do not agree, you may not use our services.
          </p>
          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            2. Services
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            Apptalyst LLC offers software development and related digital
            services. Service details are provided in our agreements and
            communications.
          </p>
          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            3. Communication Consent
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            By submitting your information through our website or otherwise
            contacting us, you consent to receive communications from us via
            email, phone calls, and SMS messages. Message and data rates may
            apply. You may opt out of SMS communications at any time by replying
            "STOP".
          </p>

          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            4. Intellectual Property
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            All content, trademarks, and intellectual property on this website
            are owned by or licensed to Apptalyst LLC. Unauthorized use is
            prohibited.
          </p>

          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            5. Limitation of Liability
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            Apptalyst LLC is not liable for any indirect, incidental, special,
            or consequential damages arising out of your use of our services or
            website.
          </p>

          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            6. Payment and Refunds
          </h2>

          <p className="text-[#616368] text-lg ">
            Specific payment terms will be outlined in individual service
            agreements. Unless otherwise agreed in writing, all payments are
            non-refundable.
          </p>
          <p className="text-[#616368]  text-lg mb-6 ">
            <span className="font-bold">Cancellation Policy: </span> If you wish
            to cancel services after a project has started, you may be liable
            for work completed up to the cancellation date. Any eligible
            refunds, if applicable, will be determined on a case-by-case basis
            and processed within 7 business days.
          </p>

          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            7. Changes to Terms
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            We reserve the right to modify these Terms at any time. Changes will
            be posted on this page with an updated effective date.
          </p>

          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            8. Governing Law
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            These Terms shall be governed by the laws of the Commonwealth of
            Virginia, USA, without regard to its conflict of law principles.
          </p>
          <h2 className="text-2xl md:text-3xl text-dark font-bold pb-5">
            9. Contact Us
          </h2>
          <p className="text-[#616368]  text-lg mb-6 ">
            For any questions regarding these Terms, please contact us at:{" "}
            <span className="underline decoration-[#6D1349] text-[#6D1349]">
              {" "}
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=support@apptalyst.com&su=Subject&body=Message"
                target="_blank"
              >
                support@apptalyst.com
              </a>{" "}
            </span>
          </p>
        </div>
      </section>
    </>
  );
}

export default TermsAndConditions;
